import { api } from '@/services';
import type {
  BuscaApuracaoDetalhadaPayload,
  BuscaApuracaoDetalhadaResponse,
  FiltrosApuracaoDetalhada,
} from '../types';

export async function fetchBuscaApuracaoDetalhada(
  filtros?: FiltrosApuracaoDetalhada
): Promise<BuscaApuracaoDetalhadaResponse> {
  const cnpjContribuinte = (filtros?.empresaId || '').replace(/\D/g, '');

  const payload: BuscaApuracaoDetalhadaPayload = {
    data_emissao_de: filtros?.dataInicio || '',
    data_emissao_ate: filtros?.dataFim || '',
    CNPJ_Contribuinte: cnpjContribuinte,
  };

  return api.post<BuscaApuracaoDetalhadaResponse, BuscaApuracaoDetalhadaPayload>(
    'Documento/BuscaApuracaoDetalhada',
    payload
  );
}
